/* Instant search results for the header overlay and in-page search forms, rendered by sections/predictive-search.liquid. */
(() => {
  const dialog = document.querySelector('[data-psearch]');
  const suggestUrl = dialog?.dataset.suggestUrl || '/search/suggest';
  const cache = new Map();
  let uid = 0;

  async function fetchResults(q, signal) {
    if (cache.has(q)) return cache.get(q);
    const params = new URLSearchParams({ q, section_id: 'predictive-search' });
    params.set('resources[type]', 'product,collection');
    params.set('resources[limit]', '6');
    params.set('resources[options][unavailable_products]', 'hide');
    // Include tags: setting, style, use and search-synonym tags are how style words reach products.
    params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
    const res = await fetch(`${suggestUrl}?${params}`, { signal, headers: { Accept: 'text/html' } });
    if (!res.ok) throw new Error(String(res.status));
    const body = new DOMParser().parseFromString(await res.text(), 'text/html').querySelector('[data-psearch-body]');
    cache.set(q, body);
    return body;
  }

  function enhance(form) {
    const input = form.querySelector('input[name="q"]');
    if (!input || form.dataset.psearch) return;
    form.dataset.psearch = '1';
    const inDialog = Boolean(form.closest('[data-psearch]'));
    const panel = document.createElement('div');
    panel.className = 'psearch__panel';
    panel.id = `PredictiveResults-${++uid}`;
    panel.hidden = true;
    const status = document.createElement('p');
    status.className = 'sr-only';
    status.setAttribute('role', 'status');
    if (inDialog) form.after(panel); else { form.classList.add('psearch-host'); form.append(panel); }
    panel.before(status);
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-expanded', 'false');
    let timer, controller;
    const items = () => [...panel.querySelectorAll('[data-psearch-item]')];
    const hide = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); };
    const show = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { controller?.abort(); panel.replaceChildren(); hide(); status.textContent = ''; return; }
      timer = setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        try {
          const body = await fetchResults(q, controller.signal);
          if (input.value.trim() !== q || !body) return;
          panel.replaceChildren(body.cloneNode(true));
          show();
          const n = Number(body.dataset.psearchCount || 0);
          status.textContent = n ? `${n} suggestions` : 'No suggestions';
        } catch (err) { if (err.name !== 'AbortError') hide(); }
      }, 160);
    });
    input.addEventListener('focus', () => { if (panel.childElementCount && input.value.trim().length >= 2) show(); });
    const scope = inDialog ? form.parentElement : form;
    scope.addEventListener('keydown', e => {
      const list = items();
      const i = list.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && list.length) { e.preventDefault(); list[Math.min(i + 1, list.length - 1)].focus(); }
      else if (e.key === 'ArrowUp' && list.length) { e.preventDefault(); if (i <= 0) input.focus(); else list[i - 1].focus(); }
      else if (e.key === 'Escape' && !inDialog && !panel.hidden) { e.preventDefault(); hide(); input.focus(); }
    });
    if (!inDialog) document.addEventListener('click', e => { if (!form.contains(e.target)) hide(); });
  }

  document.querySelectorAll('form[role="search"]').forEach(enhance);

  if (dialog && typeof dialog.showModal === 'function') {
    const input = dialog.querySelector('input[name="q"]');
    document.addEventListener('click', e => {
      const open = e.target.closest('[data-psearch-open]');
      if (open) { e.preventDefault(); dialog.showModal(); input.focus(); input.select(); return; }
      if (e.target.closest('[data-psearch-close]') || e.target === dialog) dialog.close();
    });
  }
})();
